export default __webpack_public_path__ + "static/media/banner-2.d83e3e9d.jpg";